import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  statusTab: "all",
  mainTab: "all",
  eligibility: "all",
  searchTerm: "",
  districts: [],
  fromDate: "",
  toDate: "",
  recommendedFromDate: "",
  recommendedToDate: "",
  sortOrder: "none",
};

const submissionFilterSlice = createSlice({
  name: "submissionFilter",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    setStatusTab: (state, action) => {
      state.statusTab = action.payload;
    },
    setMainTab: (state, action) => {
      state.mainTab = action.payload;
    },
    setDistricts: (state, action) => {
      state.districts = action.payload;
    },
    setSearchTerm: (state, action) => {
      state.searchTerm = action.payload;
    },
    setFromDate: (state, action) => {
      state.fromDate = action.payload;
    },
    setToDate: (state, action) => {
      state.toDate = action.payload;
    },
    setSortOrder: (state, action) => {
      state.sortOrder = action.payload;
    },
    resetFilters: () => initialState,
  },
});

export const {
  setFilters,
  setStatusTab,
  setMainTab,
  setDistricts,
  setSearchTerm,
  setFromDate,
  setToDate,
  setSortOrder,
  resetFilters,
} = submissionFilterSlice.actions;

export default submissionFilterSlice.reducer;
